module.exports = __webpack_public_path__ + "img/shipment.4d8e5e7c.svg";